import React from 'react'
import { NavLink } from 'react-router-dom';

const TABS = [
  { label: "Error Logs", icon: "bi-bug-fill", to: "/logs/error" },
  { label: "Service API Logs", icon: "bi-hdd-network-fill", to: "/logs/service-api" },
];

// Segmented switcher between the two log pages
const LogsTabs = () => (
  <div className="d-inline-flex gap-1 p-1 mb-3" style={{ background: "#fff", border: "1px solid #d5dbe8", borderRadius: 10 }}>
    {TABS.map((tab) => (
      <NavLink key={tab.to} to={tab.to} className="text-decoration-none">
        {({ isActive }) => (
          <span className="d-flex align-items-center gap-2 px-3" style={{
            height: 32, borderRadius: 8, fontSize: 13, fontWeight: 600,
            background: isActive ? "linear-gradient(135deg, var(--btn-bg) 0%, var(--btn-hover-bg) 100%)" : "transparent",
            color: isActive ? "#fff" : "#6b7a90",
          }}>
            <i className={`bi ${tab.icon}`}></i> {tab.label}
          </span>
        )}
      </NavLink>
    ))}
  </div>
);

export default LogsTabs;
